import en from "./en.json";
import es from "./es.json";
import ptBR from "./pt-BR.json";

/* ─── Shell-level i18n ───────────────────────────────────────────
   Scope: ONLY the app shell chrome that lives outside the imported
   prototype (loading state, install prompt, error boundary). The
   prototype (src/aurio.jsx) keeps its own in-file i18n
   (en-GB / en-US / pt-BR) untouched — see docs/PROJECT-PLAN.md and
   ROADMAP.md for the plan to extract it into this same structure
   without changing behavior.

   Keys stay flat and synced across all three files:
   en.json / es.json / pt-BR.json. Add a key to all three together. */

const DICTS = { en, es, "pt-BR": ptBR };

const PROTOTYPE_STORAGE_KEY = "aurio-state-v1";
const LEGACY_STORAGE_KEY = "solvente-state-v2"; // pre-rename key, read as fallback

// Map the prototype's language ids (en-GB / en-US / pt-BR) to this
// shell's dictionary ids (en / es / pt-BR) so the shell chrome and the
// prototype content generally agree once the user has picked a language.
function mapPrototypeLang(lang) {
  if (lang === "pt-BR") return "pt-BR";
  if (lang === "es") return "es";
  if (lang === "en-GB" || lang === "en-US") return "en";
  return null;
}

function detectLang() {
  try {
    const raw = window.localStorage.getItem(PROTOTYPE_STORAGE_KEY) || window.localStorage.getItem(LEGACY_STORAGE_KEY);
    if (raw) {
      const saved = JSON.parse(raw);
      const mapped = mapPrototypeLang(saved?.lang);
      if (mapped) return mapped;
    }
  } catch {
    /* ignore malformed/absent storage */
  }

  const nav = (typeof navigator !== "undefined" && (navigator.language || navigator.userLanguage)) || "en";
  if (nav.toLowerCase().startsWith("pt")) return "pt-BR";
  if (nav.toLowerCase().startsWith("es")) return "es";
  return "en";
}

export function getShellLang() {
  return detectLang();
}

export function makeShellT(lang = detectLang()) {
  const dict = DICTS[lang] || DICTS.en;
  return (key) => dict[key] || DICTS.en[key] || key;
}
